import { render, staticRenderFns } from "./SanityBlockContent.vue?vue&type=template&id=9bad533a"
import script from "./SanityBlockContent.vue?vue&type=script&lang=js"
export * from "./SanityBlockContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports